module.exports = __webpack_public_path__ + "img/logo_QrioLock_black.2146a234.svg";